import(/* webpackMode: "eager" */ "/Users/feker/Desktop/Feker-repo/ShahenWebsite/src/app/terms-and-conditions/page.jsx");
